import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../../typography'

const TabSpecialization = ({ items, defaultIndex }) => {
  const [tabSelected, setTabSelected] = useState(defaultIndex || 1)

  const selectedContent = useMemo(() => items[tabSelected - 1] ? items[tabSelected - 1].content : null, [tabSelected])

  const selectStyle = useCallback(
    (index) => {
      if (index === tabSelected) {
        return { padding: '24px 16px' }
      }

      return { padding: 16 }
    },
    [tabSelected]
  )

  const _handleSelectTab = (indexSelect) => () => {
    setTabSelected(indexSelect)
  }

  return (
    <div className={'flex items-center flex-col relative pt-6 md:pt-16'}>
      <div className={'px-4 flex flex-wrap justify-center'}>
        {
          items.map(({ label, index }) => (
            <div
              className={
                classNames([
                  'mx-2',
                  'mb-4',
                  'w-[30%]',
                  'min-w-[250px]',
                  'border-b-2',
                  'inline-block',
                  'text-center',
                  'cursor-pointer',
                  index === tabSelected ? (index % 2 ? 'border-red-500' : 'border-green-500') : 'border-gray-400'
                ])
              }
              key={`tab-${index}`}
              onClick={_handleSelectTab(index)}
              style={{ ...selectStyle(index) }}>
              <Typography
                className={index === tabSelected ? (index % 2 ? 'text-red-500' : 'text-green-500') : 'text-gray-400'}
                weight={'bold'}>
                {label}
              </Typography>
            </div>
          ))
        }
      </div>
      {selectedContent}
    </div>
  )
}

TabSpecialization.propTypes = {
  items: PropTypes.array,
  defaultIndex: PropTypes.number
}

export default TabSpecialization
